import { takeEvery, put, call } from "redux-saga/effects"

import {
  GET_AI_TRAINING,
  GET_AI_TRAINING_BY_ID,
  GET_AI_TRAINING_CATEGORIES,
  UPSERT_AI_TRAINING,
  DELETE_AI_TRAINING,
} from "./actionTypes"

import {
  getAiTrainingSuccess,
  getAiTrainingFail,
  getAiTrainingByIdSuccess,
  getAiTrainingByIdFail,
  getAiTrainingCategoriesSuccess,
  getAiTrainingCategoriesFail,
  upsertAiTrainingSuccess,
  upsertAiTrainingFail,
  deleteAiTrainingSuccess,
  deleteAiTrainingFail,
} from "./actions"

import {
  getAiTrainingApi,
  getAiTrainingByIdApi,
  getAiTrainingCategoriesApi,
  upsertAiTrainingApi,
  deleteAiTrainingApi,
} from "helpers/backend_helper"

function* fetchAiTraining({ payload: { activeOnly, category } }) {
  try {
    const response = yield call(getAiTrainingApi, activeOnly, category)
    yield put(getAiTrainingSuccess(response))
  } catch (error) {
    yield put(getAiTrainingFail(error))
  }
}

function* fetchAiTrainingById({ payload: id }) {
  try {
    const response = yield call(getAiTrainingByIdApi, id)
    yield put(getAiTrainingByIdSuccess(response))
  } catch (error) {
    yield put(getAiTrainingByIdFail(error))
  }
}

function* fetchAiTrainingCategories() {
  try {
    const response = yield call(getAiTrainingCategoriesApi)
    yield put(getAiTrainingCategoriesSuccess(response))
  } catch (error) {
    yield put(getAiTrainingCategoriesFail(error))
  }
}

function* onUpsertAiTraining({ payload: data }) {
  try {
    const isUpdate = !!data.id
    const response = yield call(upsertAiTrainingApi, data)
    const resultData = isUpdate ? data : { ...data, id: response }
    yield put(upsertAiTrainingSuccess(resultData, isUpdate))
  } catch (error) {
    yield put(upsertAiTrainingFail(error))
  }
}

function* onDeleteAiTraining({ payload: id }) {
  try {
    yield call(deleteAiTrainingApi, { id })
    yield put(deleteAiTrainingSuccess(id))
  } catch (error) {
    yield put(deleteAiTrainingFail(error))
  }
}

function* AiTrainingSaga() {
  yield takeEvery(GET_AI_TRAINING, fetchAiTraining)
  yield takeEvery(GET_AI_TRAINING_BY_ID, fetchAiTrainingById)
  yield takeEvery(GET_AI_TRAINING_CATEGORIES, fetchAiTrainingCategories)
  yield takeEvery(UPSERT_AI_TRAINING, onUpsertAiTraining)
  yield takeEvery(DELETE_AI_TRAINING, onDeleteAiTraining)
}

export default AiTrainingSaga
